import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Trophy, } from "lucide-react";
import { Link } from "react-router-dom";
import { FacebookIcon } from "react-share";
import SEO from "@/components/SEO";

export default function Winners() {
    const { t, lang } = useI18n();
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/winners").then((r) => setItems(r.data)); }, []);
    return (
        <div>
            <SEO title={t("winners_title")} description={t("winners_sub")} />
            <section className="bg-hero-grad py-16 relative overflow-hidden">
                <span className="math-symbol text-[180px] left-[6%] top-[10%]">∫</span>
                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
                    <Trophy className="w-12 h-12 mx-auto text-brand-red" />
                    <h1 className="text-4xl sm:text-5xl font-bold text-brand-navy mt-4">{t("winners_title")}</h1>
                    <p className="text-brand-navy/65 mt-3 max-w-2xl mx-auto">{t("winners_sub")}</p>
                </div>
            </section>
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {items.map((w) => (
                        <div className="glass rounded-2xl p-6 h-full">
                                    <div className="mt-5 flex flex-row items-center justify-between gap-3 w-full">
                                        <div className="flex items-center gap-3">
                                            <img
                                                src={w.image}
                                                alt={w.name}
                                                className="w-12 h-12 rounded-full object-cover"
                                            />
                                            <div>
                                                <div className="font-semibold text-brand-navy">
                                                    {w.name}
                                                </div>
                                                <div className="text-xs text-brand-royal/80">
                                                    {w.designation}
                                                </div>
                                                <div className="text-[11px] text-brand-navy/55">
                                                    {w.department}
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <Link className="rounded-full" to={w.social_url} target="_blank" rel="noopener noreferrer">
                                                <FacebookIcon className="w-5 h-5 text-brand-red rounded-full" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
